import{a as r}from"./chunk-LKOWEUPS.js";import{a as n}from"./chunk-RAAYCPUM.js";function u(...e){return n(r(Math.ceil),e)}export{u as a};
